import { createAction } from 'redux-actions';
import { isNil, get } from 'lodash';
import { push } from 'react-router-redux';

// import { keyTransform } from 'util/helper';

import { wrapFetch } from './endpoint';

export const getHotelNewsCategory = createAction(
	'FETCH_HOTEL_NEWS_CATEGORY',
	async (lan, hotel) => {
		const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/${hotel}/newsCategory`, {
			method: 'GET',
		});

		if (status !== 200) {
			throw new Error(message);
		}

		const categoryData = {};

		const categoryList = data.map(d => {
			categoryData[d.id] = {
				id: d.id,
				label: d.name,
				value: d.id,
			};

			return d.id;
		});

		return { categoryList, categoryData };
	},
);

export const getHotelNewsList = createAction(
	'FETCH_HOTEL_NEWS_LIST',
	async (lan, hotel, { category = -1, page = 1 }) => {
		const params = {
			category: parseInt(category, 10) === -1 ? undefined : category,
			page,
		};

		const { status, message, data, meta } = await wrapFetch(
			`api/v1/web/${lan}/${hotel}/news`,
			{
				method: 'GET',
			},
			params,
		);

		if (status !== 200) {
			throw new Error(message);
		}

		const newsList = data.map(news => ({
			id: news.id,
			date: news.start_at,
			endDate: news.end_at,
			title: news.title,
			intro: news.intro,
			content: news.content,
			image: news.list_banner,
			thumbnail: news.list_banner_thumbnail,
			tags: news.category,
		}));

		return {
			newsList,
			totalPage: parseInt(meta.last_page, 10),
			currentPage: parseInt(meta.current_page, 10),
		};
	},
);

export const getMoreHotelNewsList = createAction(
	'FETCH_MORE_HOTEL_NEWS_LIST',
	(page = 1) => async (_, getState) => {
		const {
			routing: { locationBeforeTransitions: { pathname, query: { category = -1 } } },
			news: { newsList: oldList }
		} = getState();

		const hotel = pathname.split('/')[1];
		const lang = pathname.split('/')[2];

		const params = {
			category: parseInt(category, 10) === -1 ? undefined : category,
			page,
		};

		const { status, message, data = [], meta } = await wrapFetch(
			`api/v1/web/${lang}/${hotel}/news`,
			{
				method: 'GET',
			},
			params,
		);

		if (status !== 200) {
			throw new Error(message);
		}

		const newsList = data
			.map(news => ({
				id: news.id,
				date: news.start_at,
				endDate: news.end_at,
				title: news.title,
				intro: news.intro,
				content: news.content,
				image: news.list_banner,
				thumbnail: news.list_banner_thumbnail,
				tags: news.category,
			}))

		if (params.category && page === 1) {
			console.log(newsList)
			return newsList
		}

		return {
			newsList: [...oldList, ...newsList],
			totalPage: parseInt(meta.last_page, 10),
			currentPage: parseInt(meta.current_page, 10),
		};
	},
);

export const getHomeNewsList = createAction('FETCH_HOME_NEWS_LIST', async (lan, { page = 1 }) => {
	const params = {
		page,
	};

	const { status, message, data, meta } = await wrapFetch(
		`api/v1/web/${lan}/news`,
		{
			method: 'GET',
		},
		params,
	);

	if (status !== 200) {
		throw new Error(message);
	}

	const newsList = data.map(news => ({
		id: news.id,
		date: news.start_at,
		endDate: news.end_at,
		title: news.title,
		intro: news.intro,
		content: news.content,
		image: news.list_banner,
		thumbnail: news.list_banner_thumbnail,
		tags: news.category,
	}));

	return {
		newsList,
		totalPage: parseInt(meta.last_page, 10),
		currentPage: parseInt(meta.current_page, 10),
	};
});
export const getMoreHomeNewsList = createAction('FETCH_MORE_HOME_NEWS_LIST', page => async (_, getState) => {
	const {
		routing: { locationBeforeTransitions: { pathname } },
		news: { newsList: oldList }
	} = getState();

	const params = {
		page,
	};

	const lan = pathname.split('/')[2] || 'tw';

	const { status, message, data, meta } = await wrapFetch(
		`api/v1/web/${lan}/news`,
		{
			method: 'GET',
		},
		params,
	);

	if (status !== 200) {
		throw new Error(message);
	}

	const newsList = data.map(news => ({
		id: news.id,
		date: news.start_at,
		endDate: news.end_at,
		title: news.title,
		intro: news.intro,
		content: news.content,
		image: news.list_banner,
		thumbnail: news.list_banner_thumbnail,
		tags: news.category,
	}));

	return {
		newsList: [...oldList, ...newsList],
		totalPage: parseInt(meta.last_page, 10),
		currentPage: parseInt(meta.current_page, 10),
	};
});


export const getHotelNews = createAction(
	'FETCH_HOTEL_NEWS',
	(lan, hotel, newsId) => async dispatch => {
		const response = await wrapFetch(`api/v1/web/${lan}/${hotel}/news/${newsId}`, {
			method: 'GET',
		});

		if (response.status !== 200) {
			throw new Error(response.message);
		}

		const data = get(response, 'data.data');

		if (isNil(data)) {
			await dispatch(push({ pathname: `/${hotel}/${lan}` }));
			return null;
		}

		return {
			news: {
				id: data.id,
				title: data.title,
				subtitle: data.subtitle,
				content: data.content,
				date: data.start_at,
				endDate: data.end_at,
				bannerImage: data.banner,
				bannerThumbnail: data.banner_thumbnail,
				tag: get(data, 'content.category', '').length > 0 ? data.category[0].name : '',
				prevId: get(response, 'data.prev_id'),
				nextId: get(response, 'data.next_id'),
			},
		};
	},
);

export const getHomeNews = createAction('FETCH_HOME_NEWS', (lan, newsId) => async dispatch => {
	const response = await wrapFetch(`api/v1/web/${lan}/news/${newsId}`, {
		method: 'GET',
	});

	if (response.status !== 200) {
		throw new Error(response.message);
	}

	const data = get(response, 'data.data');

	if (isNil(data)) {
		await dispatch(push({ pathname: `/main/${lan}` }));
		return null;
	}

	return {
		news: {
			id: data.id,
			title: data.title,
			subtitle: data.subtitle,
			content: data.content,
			date: data.start_at,
			endDate: data.end_at,
			bannerImage: data.banner,
			bannerThumbnail: data.banner_thumbnail,
			tag: get(data, 'content.category', '').length > 0 ? data.category[0].name : '',
			prevId: get(response, 'data.prev_id'),
			nextId: get(response, 'data.next_id'),
		},
	};
});



// WEBPACK FOOTER //
// ./src/actions/news.js